import React from 'react';
export function ComparisonSection() {
  const rows = [{
    feature: 'Adaptado al mercado argentino',
    other: '❌ Genérico',
    us: '✦ 100% Argentina'
  }, {
    feature: 'Técnica de brillo profesional',
    other: '❌ Básico o incompleto',
    us: '✦ Método Diamante completo'
  }, {
    feature: 'Estrategia de ventas incluida',
    other: '❌ Solo recetas',
    us: '✦ WhatsApp + Instagram'
  }, {
    feature: 'Fotografía con celular',
    other: '❌ No incluye',
    us: '✦ Bono exclusivo completo'
  }, {
    feature: 'Proveedores reales en Argentina',
    other: '❌ Productos importados',
    us: '✦ Guía actualizada 2026'
  }, {
    feature: 'Garantía de resultado',
    other: '❌ Sin garantía',
    us: '✦ 30 días o reembolso'
  }];
  return <section className="py-10 px-5 bg-negro-suave" data-id="element-32">
      <div className="max-w-[900px] mx-auto" data-id="element-33">
        <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] text-center mb-6 text-blanco" data-id="element-34">
          ¿Por qué Efecto Diamante es diferente?
        </h2>
        <div className="rounded-2xl overflow-hidden border border-[rgba(201,149,108,0.3)] overflow-x-auto" data-id="element-35">
          <table className="w-full border-collapse min-w-[550px]" data-id="element-36">
            <thead data-id="element-37">
              <tr data-id="element-38">
                <th className="p-3 text-[14px] font-bold tracking-[1px] bg-[#1e1e1e] text-texto-claro text-left" data-id="element-39">
                  Lo que necesitás
                </th>
                <th className="p-3 text-[14px] font-bold tracking-[1px] bg-[#2a2020] text-[#888]" data-id="element-40">
                  ❌ Otros
                </th>
                <th className="p-3 text-[14px] font-bold tracking-[1px] bg-gradient-gold-rose text-negro" data-id="element-41">
                  💎 Efecto Diamante
                </th>
              </tr>
            </thead>
            <tbody data-id="element-42">
              {rows.map((row, i) => <tr key={i} data-id="element-43">
                  <td className="p-2.5 px-3 text-[13px] border-b border-[rgba(255,255,255,0.05)] bg-[#1a1a1a] text-texto-claro font-semibold" data-id="element-44">
                    {row.feature}
                  </td>
                  <td className="p-2.5 px-3 text-[13px] border-b border-[rgba(255,255,255,0.05)] bg-[#1e1e1e] text-[#666] text-center" data-id="element-45">
                    {row.other}
                  </td>
                  <td className="p-2.5 px-3 text-[13px] border-b border-[rgba(255,255,255,0.05)] bg-[rgba(201,149,108,0.08)] text-dorado text-center font-bold" data-id="element-46">
                    {row.us}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}